import { Auth } from '@aws-amplify/auth';
import { confirmUser, resendOtp } from "@mobile-dev/platform/common/redux/actions/OtpVerification";
import { sendVarificationCode } from "@mobile-dev/platform/common/redux/actions/RegisterAction";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import logo from '../../assets/images/FreightSmith_LOGO_Final.png';
import { AppConstatnt } from "../../Utils/AppConstant";
import { getApplicationFlow, getAttributeToVerify, isEclipseOpsTruck, showAlert } from '../../Utils/Utility';
import ErrornDialog from "../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../Common/LoaderButton";
import { ResendOTP } from "../Common/Otp";
import OtpInput from "../Common/Otp/OTPReader";
import { injectIntl } from 'react-intl';
import { fetchUser, verifyOTPAction } from '@mobile-dev/platform/common/redux/actions/AmplifyUserAction';
import { clearError, clearSubmitVerifyOTP, clearTransaction } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import { Toast } from 'react-bootstrap';
import { verifyPhoneNumber } from "@mobile-dev/platform/common/redux/actions/AmplifyUserAction"

function OtpScreen({ intl }) {
  const [otp, SetOtp] = useState('');
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const userData = useSelector(state => state.otpAuthentication);
  const login = useSelector(state => state.login);
  const carrierLogin = useSelector(state => state.carrierLogin);
  const errorStatus = useSelector(state => state.otpAuthentication.error);
  const incorrectOTP = useSelector(state => state.otpAuthentication.incorrectOTP);
  const otpLength = 6;
  let id, mobileNumber, unload_bill_amount, loadId = null;
  const [userType, setUserType] = useState(AppConstatnt.auth.SIGNIN);
  const [session, setSession] = useState(null);
  const appFlow = getApplicationFlow();
  const { formatMessage } = intl;
  const verifyOTP = useSelector(state => state.amplifyUser.verifyOTP)
  const error = useSelector(state => state.amplifyUser.error)

  if (location.state)
    ({ mobileNumber, id, unload_bill_amount, loadId } = location.state);

  const loads = useSelector(state => state.billed.billedPo.loads);
  const load = loads.find(load => load.load_id === id);

  // getApplicationFlow() === AppConstatnt.flow.DRIVER

  useEffect(() => {
    if (verifyOTP && verifyOTP === "SUCCESS") {
      dispatch(fetchUser())
      dispatch(clearSubmitVerifyOTP())
      updateAndNavigate()
    }
  }, [verifyOTP])

  const updateAndNavigate = async () => {
    const loggeduser = await Auth.currentAuthenticatedUser();
    await Auth.updateUserAttributes(loggeduser, { 'custom:emailVerify': 'true' });
    if (isEclipseOpsTruck(load)) {
      history.push({
        pathname: `/selectpayment/${id}`,
        state: { amount: load.total_bill_amount, selection: "Full Payment", remainingAmount: 0, totalremainingAmount: 0, total_bill_amount: load.total_bill_amount, tin: load.tax_id } // your data array of objects
      });
    } else {
      history.push({
        pathname: `/paymentdetails/${id}`,
        state: { unload_bill_amount, loadId } // your data array of objects
      })
    }
  }

  const handleSubmit = () => {
    dispatch(verifyOTPAction(getAttributeToVerify(), otp))
    SetOtp("")
  }

  useEffect(() => {
    if (error) {
      dispatch(clearError())
      showAlert(toast.TYPE.ERROR, `${formatMessage({ id: "app.otp_invalid_code_content" })}`)
    }
  }, [error])

  const handleResendOTP = () => {
    dispatch(verifyPhoneNumber(getAttributeToVerify()))
  }

  return (
    <div data-layout-config='{"darkMode":false}'>
      <form className="form-signin">
        <div className="card">
          <div className="card-header uc-blue"></div>
          <div className="card-header text-center bg-header">
            <span className="text-dark-50 fa-lg">
              <img className="img-fluid smith_logo" src={logo} alt="FreightSmith logo" />
            </span>
          </div>
          <div className="card-body p-4">
            <div className="text-center m-auto">
              <p className="text-muted mb-4">{appFlow === AppConstatnt.flow.DRIVER ? formatMessage({ id: "app.otp_driver_content" }) : formatMessage({ id: "app.otp_carrier_content" })}</p>
            </div>

            <div className="form-group">
              <div className="row">
                <OtpInput
                  OTPLength={otpLength}
                  disabled={false}
                  value={otp}
                  onChange={SetOtp}
                  inputClassName="form-control Skip otp-border"
                  otpType="number"
                />
              </div>
            </div>

            <LoaderButton
              loading={userData.loading}
              onButtonClick={handleSubmit}
              name={formatMessage({ id: "app.otp_confirm_verification_code" })}
              valid={otp.length === otpLength}
            />
            <div className="text-center m-auto">
              <p className="text-orange mt-2">{formatMessage({ id: "app.otp_do_not_referesh" })}</p>
            </div>
            <ResendOTP
              maxTime={30}
              renderTime={(remainingTime) => remainingTime !== 0 && <React.Fragment>{formatMessage({ id: "app.otp_resend_code_content" }, { time: remainingTime })}</React.Fragment>}
              className="mt-3 text-danger text-center"
              onResendClick={handleResendOTP}
              renderButton={buttonProps => {
                return (
                  <button {...buttonProps} className="btn btn">
                    {buttonProps.remainingtime === 0 && formatMessage({ id: "app.otp_resend" })}
                  </button>
                );
              }}

            />

          </div>
        </div>
        {errorStatus && <ErrornDialog
          error={errorStatus}
          open
        />}
      </form>
    </div>
  );
}

export default injectIntl(OtpScreen);
